import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Same site served on www vs apex (or any host alias): always call the API on the
// current origin so the browser never hits a cross-origin redirect on preflight.
function resolveBase() {
  if (typeof window === "undefined" || !BACKEND_URL) return `${BACKEND_URL}/api`;
  try {
    const configured = new URL(BACKEND_URL);
    const bare = (h) => h.replace(/^www\./, "");
    if (bare(configured.hostname) === bare(window.location.hostname)) {
      return `${window.location.origin}/api`;
    }
  } catch {}
  return `${BACKEND_URL}/api`;
}

export const API = resolveBase();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function fileUrl(fileId) {
  return `${API}/files/${fileId}/download`;
}

export function pdfUrl(reportId) {
  return `${API}/reports/${reportId}/pdf`;
}

export function bapsPdfUrl(reportId) {
  return `${API}/reports/${reportId}/baps/pdf`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
